import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from '@chakra-ui/react';

import { PlaceListItem } from '@/pages/types';
import { router } from '@inertiajs/react';
import { Button } from '@/trailmix/Button';
import { ProseDisplay } from '@/components/Tiptap';

type DeletePlaceListItemModalProps = {
    isOpen: boolean;
    onClose: () => void;
    placeListItem: PlaceListItem;
};

export function DeletePlaceListItemModal({ isOpen, onClose, placeListItem }: DeletePlaceListItemModalProps) {
    const toast = useToast();

    const onSubmit = () => {
        router.delete(route('place-list-items.destroy', [placeListItem.id]), {
            preserveScroll: true,
            preserveState: true,
            onSuccess: () =>
                toast({
                    title: `${placeListItem.place.name} has been successfully removed.`,
                    status: 'success',
                    position: 'top',
                    variant: 'left-accent',
                    isClosable: true,
                }),
            onError(e) {
                console.error(e);
                toast({
                    title: 'Oops, an error occurred during this request. Try refreshing your browser or contact us if it continues to persist.',
                    status: 'error',
                    position: 'top',
                    variant: 'left-accent',
                    isClosable: true,
                });
            },
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Remove List Item</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <p>
                        Are you sure you want to remove <b>{placeListItem.place.name}</b> from this list?{' '}
                        {placeListItem.notes ? 'This will also delete your note:' : ''}
                    </p>
                    {placeListItem.notes && <ProseDisplay content={placeListItem.notes} className='mt-4' />}
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button onClick={onClose} variant='secondary' className='grow'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            onSubmit();
                            onClose();
                        }}
                        variant='danger'
                        className='grow'
                    >
                        Remove
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
